import React, { useState } from 'react'
import { Button, Form, FormControl } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

/**
 * Password input with a hide or show password button
 * @param className
 * @param label
 * @param name
 * @param value
 * @param onChange
 * @param isInvalid
 * @param autoComplete
 * @returns {*}
 * @constructor
 */
const PasswordShowHide = ({
    className = '',
    label,
    name,
    value,
    onChange,
    isInvalid,
    autoComplete = 'on',
}) => {
    const [hidden, setHidden] = useState(true);
    const eye = <FontAwesomeIcon icon={faEye} />;
    const eyeSlash = <FontAwesomeIcon icon={faEyeSlash} />;

    return (
        <React.Fragment>
            <FormControl
                className="psw"
                type={hidden ? 'password' : 'text'}
                name={name}
                value={value}
                onChange={onChange}
                isInvalid={isInvalid}
                autoComplete={autoComplete}
            />
            <Form.Label>{label}</Form.Label>
            {
                <Button
                    variant="link"
                    className="btn-psw"
                    tabIndex="-1"
                    onClick={() => setHidden(!hidden)}
                >
                    {hidden ? eye : eyeSlash}
                </Button>
            }
        </React.Fragment>
    );
};

export default PasswordShowHide;
